import { createTheme } from "@mui/material/styles";
import colors from "./colors";

const body = [
  "Inter",
  "-apple-system",
  "BlinkMacSystemFont",
  "Segoe UI",
  "Roboto",
  "sans-serif",
].join(",");

const theme = createTheme({
  typography: {
    fontFamily: body,
    h1: { fontFamily: body, fontWeight: 600 },
    h2: { fontFamily: body, fontWeight: 600 },
    h3: { fontFamily: body, fontWeight: 600 },
    h4: { fontFamily: body, fontWeight: 600 },
    h5: { fontFamily: body, fontWeight: 600 },
    h6: { fontFamily: body, fontWeight: 600 },
    button: { fontFamily: body, fontWeight: 600, textTransform: "none" },
  },
  breakpoints: {
    values: {
      xs: 0, //For mobile devices (0 < W < 480)
      sm: 481, //iPads and Tablets (480 < W < 768)
      md: 769, //Laptops and small screens (768 < W < 1024)
      lg: 1025, //Large screens and Desktops (1024 < W < 1200)
      xl: 1201, //TV and Extra Large Screens (W > 1200)
    },
  },
  palette: {
    primary: {
      main: colors.dark,
      contrastText: colors.white,
    },
    secondary: {
      main: colors.accent,
      contrastText: colors.dark,
    },
    accent: {
      main: colors.accent,
    },
    error: {
      main: colors.red,
    },
    background: {
      default: colors.surface,
      paper: colors.surfaceAlt,
    },
    text: {
      primary: colors.text,
      secondary: colors.textMuted,
    },
  },
  shape: {
    borderRadius: 10,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 999,
          fontWeight: 600,
          letterSpacing: "0.01em",
          boxShadow: "none",
          "&:hover": { boxShadow: "none" },
        },
        containedPrimary: {
          backgroundColor: colors.dark,
          color: colors.white,
          "&:hover": { backgroundColor: colors.accent, color: colors.dark },
        },
        outlinedPrimary: {
          borderColor: colors.dark,
          color: colors.dark,
          "&:hover": {
            borderColor: colors.accent,
            color: colors.accent,
            backgroundColor: "transparent",
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: colors.accent,
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: colors.accent,
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: colors.textMuted, // default color
          "&.Mui-checked": {
            color: colors.accent, // color when checked
          },
          "&.MuiCheckbox-indeterminate": {
            color: colors.accent, // color when indeterminate
          },
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: colors.textMuted, // default color
          "&.Mui-checked": {
            color: colors.accent, // color when checked
          },
        },
      },
    },
    MuiSnackbarContent: {
      styleOverrides: {
        root: {
          backgroundColor: colors.dark,
        },
        message: {
          color: colors.white,
        },
      },
    },
  },
});

export default theme;
